import { render, staticRenderFns } from "./ForceChangePassword.vue?vue&type=template&id=11bf09af"
import script from "./ForceChangePassword.vue?vue&type=script&lang=ts"
export * from "./ForceChangePassword.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports